import Input from './Input';

export default Input;



// WEBPACK FOOTER //
// ./app/javascript/common/components/Input/index.js